import TransportersPage from '@/views/restricted/dashboard/transporter/TransportersPage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import ExpressistConnexionCreatePage
  from '@/views/restricted/dashboard/transporter/expressist/ExpressistConnexionCreatePage.vue'
import ExpressistConnexionEditPage
  from '@/views/restricted/dashboard/transporter/expressist/ExpressistConnexionEditPage.vue'
import ExpressistConnexionDetailPage
  from '@/views/restricted/dashboard/transporter/expressist/ExpressistConnexionDetailPage.vue'

export default [
  {
    path: '/dashboard/transporters',
    name: 'Transporters',
    menuSelected: 'transporters',
    component: TransportersPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_TRANSPORTER_READ_PERMISSION']
    }
  },
  {
    path: '/dashboard/transporters/expressist/new/:storeId',
    name: 'ExpressistConnexionCreatePage',
    menuSelected: 'transporters',
    component: ExpressistConnexionCreatePage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_TRANSPORTER_CREATE_PERMISSION']
    }
  },
  {
    path: '/dashboard/transporters/expressist/update/:expressistConnexionId',
    name: 'ExpressistConnexionEditPage',
    menuSelected: 'transporters',
    component: ExpressistConnexionEditPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_TRANSPORTER_UPDATE_PERMISSION']
    }
  },
  {
    path: '/dashboard/transporters/expressist/detail/:expressistConnexionLinkId',
    name: 'ExpressistDetailPage',
    menuSelected: 'transporters',
    component: ExpressistConnexionDetailPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_TRANSPORTER_READ_PERMISSION']
    }
  }
]
